import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProgressJourney from './components/ProgressJourney';
import MicroCredits from './components/MicroCredits';
import Microcourses from './components/Microcourses';
import BadgesSection from './components/BadgesSection';
import MeritPathways from './components/MeritPathways';
import AIPathway from './components/AIPathway';
import SkillProfile from './components/SkillProfile';
import WhyStudentsLove from './components/WhyStudentsLove';
import EarlyAccessBanner from './components/EarlyAccessBanner';
import FinalCTA from './components/FinalCTA';
import UniversitiesSection from './components/UniversitiesSection';
import Footer from './components/Footer';
import AITutorWidget from './components/AITutorWidget';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Microcourses />
      <ProgressJourney />
      <MicroCredits />
      <BadgesSection />
      <MeritPathways />
      <AIPathway />
      <SkillProfile />
      <WhyStudentsLove />
      <EarlyAccessBanner />
      <FinalCTA />
      <UniversitiesSection />
      <Footer />
      <AITutorWidget />
    </div>
  );
}
